<template>
	<b-container fluid class="w-100" @mouseup="endDragging()">
		<!-- <Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)" spinner-size="15px" /> -->
		<b-row id="resizible-wrapper" tag="main" class="flex-md-nowrap  position-relative">
			<DynamicNav class="pt-2 pt-md-5 aside-secondary"
				:style="{ width: `${dividerPosition}%`, 'flex-basis': `${dividerPosition}%` }" />
			<div class="aside-divider" :style="{
				left: `${dividerPosition}%`
			}" @mousedown="startDragging()">
			</div>
			<b-col v-if="loadingStatus" class="container-mw mr-auto ml-xl-3 ml-xxl-5 mt-2 mt-md-5 ">
				<Spinner text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)"
					spinner-size="15px" />
			</b-col>
			<b-col v-else class="container-mw container-mw_mobile-100 mr-auto pl-xl-3 pl-xxl-5 mt-2 mt-md-5"
				:style="{ width: `${100 - dividerPosition}%`, 'flex-basis': `${100 - dividerPosition}%` }">
				<div class="d-flex mb-4">
					<h1 ref="title" class="text-s-xxl text-500 title rounded" :class="{ 'title-editable': allowEditTitle }"
						:contenteditable="allowEditTitle" @click="editPlayerName" @blur="saveNewPlayerName"
						@keyup.enter="saveNewPlayerName" v-text="player && player.name" />
					<b-dropdown class="d-block d-md-none" right variant="transparent" size="md" id=""
						menu-class="bg-dark-3 dropdown-menu_md" toggle-class="justify-content-end justify-content-md-between">
						<template #button-content>
							&nbsp;
						</template>
						<b-dropdown-item v-for="(player, index) in players" :key="index" @click="goToPlayer(player._id)"
							class="d-flex align-items-center">
							<span class="text-truncate">{{ player.name }}</span>
						</b-dropdown-item>
					</b-dropdown>
					<div class="d-none d-md-flex flex-column align-items-start ml-auto mr-2 dynamic_players_doc">
						<a class="text-s-s text-dark-6 dynamic_players_doc" target="_blank"
							href="https://docs.castr.com/en/articles/7785953-how-to-create-a-dynamic-player">
							<svg width="16" height="16" class="mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M8 15V5C8 3.61929 6.88071 2.5 5.5 2.5H1.5V12.5H5.75C6.99264 12.5 8 13.5074 8 14.75V15Z"
									stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
								<path d="M8 15V5C8 3.61929 9.11929 2.5 10.5 2.5H14.5V12.5H10.25C9.00736 12.5 8 13.5074 8 14.75V15Z"
									stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
							</svg>How Dynamic Players works</a>
						<b-button class="text-s-s text-dark-6 px-0 py-0 font-weight-normal dynamic_players_demo"
							variant="outlines-secondary" v-b-modal.modal-demo-video>
							<svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M4.9999 1.6499H4.97411C4.29592 1.6499 3.75045 1.64989 3.30905 1.68596C2.85506 1.72305 2.4586 1.80126 2.09253 1.98778C1.50923 2.28499 1.03499 2.75923 0.737783 3.34253C0.55126 3.7086 0.473048 4.10506 0.435956 4.55905C0.399892 5.00045 0.399897 5.54592 0.399902 6.22411V6.2499V9.7499V9.7757C0.399897 10.4539 0.399892 10.9994 0.435956 11.4408C0.473048 11.8947 0.55126 12.2912 0.737783 12.6573C1.03499 13.2406 1.50923 13.7148 2.09253 14.012C2.4586 14.1985 2.85506 14.2768 3.30905 14.3138C3.75045 14.3499 4.29593 14.3499 4.97411 14.3499H4.97412H4.9999H10.9999H11.0257H11.0257C11.7039 14.3499 12.2494 14.3499 12.6908 14.3138C13.1447 14.2768 13.5412 14.1985 13.9073 14.012C14.4906 13.7148 14.9648 13.2406 15.262 12.6573C15.4485 12.2912 15.5268 11.8947 15.5638 11.4408C15.5999 10.9994 15.5999 10.4539 15.5999 9.77569V9.77568V9.7499V6.2499V6.22412V6.22411C15.5999 5.54593 15.5999 5.00045 15.5638 4.55905C15.5268 4.10506 15.4485 3.7086 15.262 3.34253C14.9648 2.75923 14.4906 2.28499 13.9073 1.98778C13.5412 1.80126 13.1447 1.72305 12.6908 1.68596C12.2494 1.64989 11.7039 1.6499 11.0257 1.6499H10.9999H4.9999ZM2.63732 3.05699C2.80603 2.97103 3.02699 2.913 3.40677 2.88197C3.79355 2.85037 4.28994 2.8499 4.9999 2.8499H10.9999C11.7099 2.8499 12.2063 2.85037 12.593 2.88197C12.9728 2.913 13.1938 2.97103 13.3625 3.05699C13.72 3.23915 14.0107 3.52981 14.1928 3.88732C14.2788 4.05603 14.3368 4.27699 14.3678 4.65677C14.3994 5.04355 14.3999 5.53994 14.3999 6.2499V9.7499C14.3999 10.4599 14.3994 10.9563 14.3678 11.343C14.3368 11.7228 14.2788 11.9438 14.1928 12.1125C14.0107 12.47 13.72 12.7607 13.3625 12.9428C13.1938 13.0288 12.9728 13.0868 12.593 13.1178C12.2063 13.1494 11.7099 13.1499 10.9999 13.1499H4.9999C4.28994 13.1499 3.79355 13.1494 3.40677 13.1178C3.02699 13.0868 2.80603 13.0288 2.63732 12.9428C2.27981 12.7607 1.98915 12.47 1.80699 12.1125C1.72103 11.9438 1.663 11.7228 1.63197 11.343C1.60037 10.9563 1.5999 10.4599 1.5999 9.7499V6.2499C1.5999 5.53994 1.60037 5.04355 1.63197 4.65677C1.663 4.27699 1.72103 4.05603 1.80699 3.88732C1.98915 3.52981 2.27981 3.23915 2.63732 3.05699ZM10.2469 7.9999L6.5999 9.98918V6.01063L10.2469 7.9999ZM7.02664 4.87649C6.29363 4.47666 5.3999 5.00721 5.3999 5.84217V10.1576C5.3999 10.9926 6.29363 11.5231 7.02664 11.1233L10.9825 8.96559C11.7468 8.54867 11.7468 7.45114 10.9825 7.03422L7.02664 4.87649Z"
									fill="#8794B5" />
							</svg>
							Dynamic Players Demo
						</b-button>
					</div>
					<b-button @click="togglePlayer" variant="outline-secondary" size="md" class="ml-2 mr-2 d-none d-md-block">
						<span v-if="player.enabled">Disable</span>
						<span v-else>Enable</span>
					</b-button>
					<b-button @click="showAddPlayerModal" size="sm" class="p-2 d-lg-none mt-1 ml-auto ml-md-0"
						variant="outline-secondary">
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M6.99999 0.899994C7.33136 0.899994 7.59999 1.16862 7.59999 1.49999V6.39999H12.5C12.8314 6.39999 13.1 6.66862 13.1 6.99999C13.1 7.33136 12.8314 7.59999 12.5 7.59999H7.59999V12.5C7.59999 12.8314 7.33136 13.1 6.99999 13.1C6.66862 13.1 6.39999 12.8314 6.39999 12.5V7.59999H1.49999C1.16862 7.59999 0.899994 7.33136 0.899994 6.99999C0.899994 6.66862 1.16862 6.39999 1.49999 6.39999H6.39999V1.49999C6.39999 1.16862 6.66862 0.899994 6.99999 0.899994Z"
								fill="#8794B5" />
						</svg>
					</b-button>
					<b-dropdown menu-class="dropdown-menu_md" right no-caret variant="icon" size="md" toggle-class="px-0" class="">
						<template #button-content>
							<svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M3 2C3 2.69036 2.44036 3.25 1.75 3.25C1.05964 3.25 0.5 2.69036 0.5 2C0.5 1.30964 1.05964 0.75 1.75 0.75C2.44036 0.75 3 1.30964 3 2ZM8.25 2C8.25 2.69036 7.69036 3.25 7 3.25C6.30964 3.25 5.75 2.69036 5.75 2C5.75 1.30964 6.30964 0.75 7 0.75C7.69036 0.75 8.25 1.30964 8.25 2ZM12.25 3.25C12.9404 3.25 13.5 2.69036 13.5 2C13.5 1.30964 12.9404 0.75 12.25 0.75C11.5596 0.75 11 1.30964 11 2C11 2.69036 11.5596 3.25 12.25 3.25Z"
									fill="#68759C" />
							</svg>
						</template>
						<b-dropdown-item class="d-block d-md-none" @click="togglePlayer" variant="">
							<svg class="mr-2 d-none d-md-block" width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="10" cy="4" rx="7" ry="2" stroke="currentColor" stroke-width="1.5" />
								<path d="M17 4L15.5 16C15 17.5 12 18 10 18C8 18 5 17.5 4.5 16L3 4" stroke="currentColor"
									stroke-width="1.5" />
							</svg>
							<span v-if="player.enabled">Disable</span>
							<span v-else>Enable</span>
						</b-dropdown-item>
						<b-dropdown-item @click="showDeleteModal" variant="delete">
							<svg class="mr-2 d-none d-md-block" width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="10" cy="4" rx="7" ry="2" stroke="currentColor" stroke-width="1.5" />
								<path d="M17 4L15.5 16C15 17.5 12 18 10 18C8 18 5 17.5 4.5 16L3 4" stroke="currentColor"
									stroke-width="1.5" />
							</svg>
							<span>Delete</span>
						</b-dropdown-item>
					</b-dropdown>
				</div>
				<b-row>
					<b-col lg="8">
						<b-alert
							v-if="hasLiveSubscription && !hasLiveSubscription.enabled || !hasLiveSubscription && hasVodSubscription && !hasVodSubscription.enabled"
							variant="danger" show class="d-flex align-items-start">
							<svg class="mr-2 flex-shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M4.57328 3.12854C5.18596 2.51587 5.38162 2.33522 5.61326 2.23928C5.8449 2.14333 6.11099 2.13271 6.97745 2.13271L9.02131 2.13271C9.88776 2.13271 10.1538 2.14333 10.3855 2.23928C10.6171 2.33522 10.8128 2.51587 11.4255 3.12854L12.8707 4.57377C13.4834 5.18645 13.664 5.38211 13.76 5.61375C13.8559 5.84539 13.8665 6.11148 13.8665 6.97793V9.0218C13.8665 9.88825 13.8559 10.1543 13.76 10.386C13.664 10.6176 13.4834 10.8133 12.8707 11.426L11.4255 12.8712C10.8128 13.4839 10.6171 13.6645 10.3855 13.7605C10.1538 13.8564 9.88776 13.867 9.02131 13.867L6.97744 13.867C6.11099 13.867 5.8449 13.8564 5.61326 13.7605C5.38162 13.6645 5.18596 13.4839 4.57328 12.8712L3.12806 11.426C2.51538 10.8133 2.33474 10.6176 2.23879 10.386C2.14284 10.1543 2.13222 9.88825 2.13222 9.02179L2.13222 6.97793C2.13222 6.11148 2.14284 5.84539 2.23879 5.61375C2.33474 5.38211 2.51538 5.18645 3.12806 4.57377L4.57328 3.12854ZM5.15404 1.13062C4.67417 1.32939 4.30427 1.69977 3.80006 2.20465L3.72476 2.28002L2.27953 3.72524L2.20416 3.80054C1.69929 4.30476 1.3289 4.67466 1.13013 5.15453C0.931362 5.6344 0.931706 6.15786 0.932173 6.8714L0.93222 6.97793V9.02179L0.932173 9.12833C0.931706 9.84186 0.931362 10.3653 1.13013 10.8452C1.3289 11.3251 1.69929 11.695 2.20417 12.1992L2.27953 12.2745L3.72476 13.7197L3.80005 13.7951C4.30427 14.3 4.67417 14.6703 5.15404 14.8691C5.63392 15.0679 6.15738 15.0675 6.87092 15.0671L6.97744 15.067H9.0213L9.12785 15.0671C9.84138 15.0675 10.3648 15.0679 10.8447 14.8691C11.3246 14.6703 11.6945 14.3 12.1987 13.7951L12.274 13.7197L13.7192 12.2745L13.7946 12.1992L13.7946 12.1992C14.2995 11.695 14.6698 11.3251 14.8686 10.8452C15.0674 10.3653 15.067 9.84187 15.0666 9.12834V9.12832L15.0665 9.0218V6.97793L15.0666 6.8714C15.067 6.15786 15.0674 5.6344 14.8686 5.15453C14.6698 4.67466 14.2995 4.30476 13.7946 3.80054L13.7192 3.72524L12.274 2.28002L12.1987 2.20465L12.1987 2.20464C11.6945 1.69977 11.3246 1.32939 10.8447 1.13062C10.3648 0.931851 9.84138 0.932194 9.12784 0.932662L9.02131 0.932708H6.97745L6.87091 0.932662C6.15737 0.932194 5.63392 0.931851 5.15404 1.13062ZM6.67465 5.82559C6.44034 5.59127 6.06044 5.59126 5.82612 5.82557C5.5918 6.05987 5.59178 6.43977 5.82609 6.67409L7.15175 7.99984L5.82609 9.32559C5.59178 9.55992 5.5918 9.93982 5.82612 10.1741C6.06044 10.4084 6.44034 10.4084 6.67465 10.1741L8.00028 8.84837L9.32612 10.1741C9.56044 10.4084 9.94034 10.4084 10.1746 10.1741C10.409 9.93977 10.4089 9.55987 10.1746 9.32557L8.8488 7.99984L10.1746 6.67412C10.4089 6.43982 10.409 6.05992 10.1746 5.82559C9.94034 5.59127 9.56044 5.59126 9.32612 5.82557L8.00028 7.15132L6.67465 5.82559Z"
									fill="white" />
							</svg>
							<p class="text-s-s mb-0">Your plan has ended. Please <a class="text-underline text-reset" target="_blank"
									href="/app/subscribe">upgrade</a> to continue.</p>
						</b-alert>
					</b-col>
				</b-row>
				<b-row>
					<b-col lg="8">
						<div v-if="!playerLoaded"
							class="video-placeholder test-s-l text-500 text-dark-4 d-flex align-items-center justify-content-center flex-wrap bg-darker">
							<Spinner text="Retrieving data..." classes="text-dark-8" spinner-color="var(--c-dark-8)"
								spinner-size="15px" />
						</div>
						<div v-else-if="player && !player.enabled"
							class="video-placeholder test-s-l text-500 text-dark-4 d-flex align-items-center justify-content-center flex-wrap bg-darker">
							<p class="text-dark-8 text-s-l w-100 text-center mb-2 mt-auto">
								Disabled Stream
							</p>
							<p class="text-dark-6 text-s-s w-100 text-center mb-auto">Please enable</p>
						</div>
						<div v-else>
							<div v-if="player && !player.source"
								class="video-placeholder test-s-l text-500 text-dark-4 d-flex align-items-center justify-content-center bg-darker">
								<div class="d-flex text-dark-6 text-s-s select-arrow">
									Select source first
									<svg class="mt-n3 ml-2" width="48" height="22" viewBox="0 0 48 22" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M47.5303 6.53033C47.8232 6.23744 47.8232 5.76256 47.5303 5.46967L42.7574 0.696699C42.4645 0.403806 41.9896 0.403806 41.6967 0.696699C41.4038 0.989593 41.4038 1.46447 41.6967 1.75736L45.9393 6L41.6967 10.2426C41.4038 10.5355 41.4038 11.0104 41.6967 11.3033C41.9896 11.5962 42.4645 11.5962 42.7574 11.3033L47.5303 6.53033ZM0 21.25C0.722801 21.25 1.42601 21.2365 2.11077 21.2102L2.05322 19.7113C1.38808 19.7368 0.704064 19.75 0 19.75V21.25ZM6.32553 20.8661C7.80755 20.6765 9.19408 20.4218 10.5015 20.1137L10.1573 18.6537C8.90117 18.9498 7.56599 19.1952 6.1352 19.3782L6.32553 20.8661ZM14.5638 18.9132C15.949 18.4179 17.2424 17.8651 18.4722 17.2767L17.8247 15.9236C16.6347 16.493 15.3891 17.0251 14.0588 17.5008L14.5638 18.9132ZM22.1988 15.313C23.4251 14.6169 24.6187 13.9016 25.8003 13.2039L25.0376 11.9123C23.8449 12.6166 22.6699 13.3208 21.4583 14.0085L22.1988 15.313ZM29.3893 11.1643C30.574 10.5319 31.7909 9.9358 33.0762 9.39814L32.4974 8.01433C31.1588 8.57427 29.8985 9.19213 28.683 9.84096L29.3893 11.1643ZM36.9178 8.05389C38.156 7.70476 39.4712 7.41356 40.8851 7.19557L40.6566 5.71308C39.1816 5.94048 37.8069 6.24471 36.5107 6.61018L36.9178 8.05389ZM44.9514 6.79631C45.6134 6.76581 46.2957 6.75 47 6.75V5.25C46.2733 5.25 45.5679 5.26631 44.8823 5.2979L44.9514 6.79631Z"
											fill="#404B72" />
									</svg>
								</div>
								Nothing to display
							</div>
							<iframe v-else-if="playerUrl" :src="playerUrl" class="embed video-frame" frameborder="0" width="100%"
								scrolling="no" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen
								msallowfullscreen />
							<div v-if="sourceLiveStream && !mediaPulse || sourceLiveStream && !mediaPulse.alive"
								class="video-placeholder test-s-l text-500 text-dark-4 d-flex align-items-center justify-content-center bg-darker">
								Stream Offline
							</div>
							<stream-player-dynamic
								v-else-if="sourceLiveStream && mediaPulse && streamPreviewSpecsUrl && streamPreviewSpecsType === 'mse'"
								:stream="sourceLiveStream" :stream-url="streamPreviewSpecsUrl" :media-pulse="mediaPulse"
								class="video-wrapper bg-darker d-flex justify-content-center align-items-center" />

							<stream-player-hls-dynamic
								v-else-if="sourceLiveStream && mediaPulse && streamPreviewSpecsUrl && streamPreviewSpecsType === 'hls'"
								:stream="sourceLiveStream" :stream-url="streamPreviewSpecsUrl" :autoplay="true" :frameless="true"
								class="video-wrapper" />
						</div>

					</b-col>
					<b-col lg="4">
						<div class="d-flex justify-content-between align-items-center text-dark-6 mb-2 mt-4 mt-md-0">
							<h6 class="text-dark-8 text-s-s text-500 m-0">Source</h6>
							<b-button v-if="player && player.source" variant="icon" size="xs" class="p-0 text-s-s text-reset border-0"
								@click="setElement(null)">Remove</b-button>
						</div>
						<b-dropdown :disabled="hasLiveSubscription && !hasLiveSubscription.enabled" ref="source" right
							variant="dark-3" size="md" id="stream-source" menu-class="bg-dark-3 stream-source-menu"
							toggle-class="justify-content-between text-truncate" class="w-100">
							<template #button-content>
								<div class="text-truncate">{{ playerSourceTitle ? playerSourceTitle.slice(0, 40) : source.name.slice(0,
									40) }}</div>
							</template>
							<b-dropdown-text text-class="px-0">
								<b-tabs class="tabs-light" nav-class="px-3 tabs-light-border">
									<div v-if="allInOneStreams.length > 0 || vodStreams.length > 0" class="px-2 my-3">
										<b-input-group size="md" class="bg-dark-5 rounded">
											<template #prepend>
												<b-input-group-text class="bg-transparent border-0 text-dark-6">
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd"
															d="M2.25 6.75C2.25 4.26472 4.26472 2.25 6.75 2.25C9.23528 2.25 11.25 4.26472 11.25 6.75C11.25 9.23528 9.23528 11.25 6.75 11.25C4.26472 11.25 2.25 9.23528 2.25 6.75ZM6.75 0.75C3.43629 0.75 0.75 3.43629 0.75 6.75C0.75 10.0637 3.43629 12.75 6.75 12.75C8.13653 12.75 9.41322 12.2797 10.4292 11.4899L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.4899 10.4292C12.2797 9.41322 12.75 8.13653 12.75 6.75C12.75 3.43629 10.0637 0.75 6.75 0.75Z"
															fill="currentColor" />
													</svg>
												</b-input-group-text>
											</template>
											<b-form-input ref="searchWidgetInputElement" placeholder="Search for files" size="md"
												class="border-0" v-model="search"></b-form-input>
											<b-button @click="search = ''" variant="icon" size="md" class="search-clear"
												:class="{ 'active': search.length > 0 }">
												<svg class="text-dark-8" width="16" height="17" viewBox="0 0 16 17" fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd"
														d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5ZM6.03033 5.46967C5.73744 5.17678 5.26256 5.17678 4.96967 5.46967C4.67678 5.76256 4.67678 6.23744 4.96967 6.53033L6.93934 8.5L4.96967 10.4697C4.67678 10.7626 4.67678 11.2374 4.96967 11.5303C5.26256 11.8232 5.73744 11.8232 6.03033 11.5303L8 9.56066L9.96967 11.5303C10.2626 11.8232 10.7374 11.8232 11.0303 11.5303C11.3232 11.2374 11.3232 10.7626 11.0303 10.4697L9.06066 8.5L11.0303 6.53033C11.3232 6.23744 11.3232 5.76256 11.0303 5.46967C10.7374 5.17678 10.2626 5.17678 9.96967 5.46967L8 7.43934L6.03033 5.46967Z"
														fill="currentColor" />
												</svg>
											</b-button>
										</b-input-group>
									</div>
									<b-tab title="Livestreams" active>
										<div class="text-center text-s-s text-dark-7 mt-3 mb-1" v-if="allInOneStreams.length === 0">
											Please create an All in One stream.
										</div>
										<b-list-group v-else class="stream-source-list mt-2">
											<b-list-group-item button variant="dark-3" v-for="(item, index) in  allInOneStreamsFiltered"
												:key="index" @click="setElement(item)"
												class="d-flex align-items-center text-dark-8 px-3 py-2 text-s-s text-truncate flex-shrink-0">
												<svg class="mr-2 flex-shrink-0" width="16" height="12" viewBox="0 0 16 12" fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd"
														d="M4.9999 0.399902H4.97411C4.29592 0.399897 3.75045 0.399892 3.30905 0.435956C2.85506 0.473048 2.4586 0.55126 2.09253 0.737783C1.50923 1.03499 1.03499 1.50923 0.737783 2.09253C0.55126 2.4586 0.473048 2.85506 0.435956 3.30905C0.399892 3.75045 0.399897 4.29592 0.399902 4.97411V4.9999V6.9999V7.0257C0.399897 7.70388 0.399892 8.24936 0.435956 8.69076C0.473048 9.14474 0.55126 9.5412 0.737783 9.90727C1.03499 10.4906 1.50923 10.9648 2.09253 11.262C2.4586 11.4485 2.85506 11.5268 3.30905 11.5638C3.75045 11.5999 4.29593 11.5999 4.97411 11.5999H4.97412H4.9999H6.9999H7.02568H7.02569C7.70388 11.5999 8.24936 11.5999 8.69076 11.5638C9.14474 11.5268 9.5412 11.4485 9.90727 11.262C10.4906 10.9648 10.9648 10.4906 11.262 9.90727C11.4485 9.5412 11.5268 9.14474 11.5638 8.69076C11.579 8.50555 11.5878 8.30202 11.5929 8.07805L13.9169 9.53058C14.6496 9.98849 15.5999 9.46176 15.5999 8.59778V3.40203C15.5999 2.53805 14.6496 2.01132 13.9169 2.46923L11.5929 3.92176C11.5878 3.69779 11.579 3.49426 11.5638 3.30905C11.5268 2.85506 11.4485 2.4586 11.262 2.09253C10.9648 1.50923 10.4906 1.03499 9.90727 0.737783C9.5412 0.55126 9.14474 0.473048 8.69076 0.435956C8.24936 0.399892 7.70388 0.399897 7.0257 0.399902H6.9999H4.9999ZM11.5999 5.33245V6.66735L14.3999 8.41735V3.58245L11.5999 5.33245ZM10.3999 5.27703V4.9999C10.3999 4.28994 10.3994 3.79355 10.3678 3.40677C10.3368 3.02699 10.2788 2.80603 10.1928 2.63732C10.0107 2.27981 9.71999 1.98915 9.36248 1.80699C9.19378 1.72103 8.97281 1.663 8.59304 1.63197C8.20626 1.60037 7.70987 1.5999 6.9999 1.5999H4.9999C4.28994 1.5999 3.79355 1.60037 3.40677 1.63197C3.02699 1.663 2.80603 1.72103 2.63732 1.80699C2.27981 1.98915 1.98915 2.27981 1.80699 2.63732C1.72103 2.80603 1.663 3.02699 1.63197 3.40677C1.60037 3.79355 1.5999 4.28994 1.5999 4.9999V6.9999C1.5999 7.70987 1.60037 8.20626 1.63197 8.59304C1.663 8.97281 1.72103 9.19378 1.80699 9.36248C1.98915 9.71999 2.27981 10.0107 2.63732 10.1928C2.80603 10.2788 3.02699 10.3368 3.40677 10.3678C3.79355 10.3994 4.28994 10.3999 4.9999 10.3999H6.9999C7.70987 10.3999 8.20626 10.3994 8.59304 10.3678C8.97281 10.3368 9.19378 10.2788 9.36248 10.1928C9.71999 10.0107 10.0107 9.71999 10.1928 9.36248C10.2788 9.19378 10.3368 8.97281 10.3678 8.59304C10.3994 8.20626 10.3999 7.70987 10.3999 6.9999V6.72278V5.27703Z"
														fill="currentColor" />
												</svg>
												<span class="d-block text-truncate">{{ item.name }}</span>
											</b-list-group-item>
										</b-list-group>
									</b-tab>
									<b-tab title="VOD Files">
										<div class="text-center text-s-s text-dark-7 mt-3 mb-1" v-if="vodStreams.length === 0">
											Please upload files in Video Hosting.
										</div>
										<b-list-group v-else role="tablist" class="stream-source-list accordion mt-2">
											<b-list-group-item variant="dark-3" v-for="(item, index) in  vodStreamsFiltered" :key="index"
												class="d-flex align-items-center flex-wrap  text-dark-8 px-3 py-2 text-s-s text-truncate flex-shrink-0">
												<div class="w-100 d-flex align-items-center cursor-pointer" role="tab">
													<b-button variant="icon" size="xs" :class="true ? null : 'collapsed'"
														:aria-expanded="true ? 'true' : 'false'" aria-controls="collapse-4"
														@click="getVodFiles(item._id)" class="pl-0 pr-2 py-0 collapse-b">
														<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M2.73137 1.73123L4.86863 3.86848C5.26465 4.2645 5.46265 4.46251 5.53684 4.69084C5.6021 4.89168 5.6021 5.10803 5.53684 5.30887C5.46265 5.5372 5.26465 5.73521 4.86863 6.13123L2.73137 8.26848C1.87462 9.12524 1.44624 9.55361 1.07846 9.58256C0.759341 9.60767 0.447486 9.4785 0.239594 9.23509C0 8.95456 0 8.34874 0 7.13711V2.8626C0 1.65096 0 1.04515 0.239594 0.76462C0.447486 0.52121 0.759341 0.392035 1.07846 0.417151C1.44624 0.446096 1.87462 0.874473 2.73137 1.73123Z"
																fill="#D1DBF0" />
														</svg>
													</b-button>
													<svg class="mr-2 flex-shrink-0" width="16" height="14" viewBox="0 0 16 14" fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd"
															d="M5.5798 1.62851C5.45431 1.60276 5.31747 1.59993 4.8774 1.59993H4.6999C4.12995 1.59993 3.73857 1.60039 3.43517 1.62518C3.13877 1.6494 2.97955 1.6938 2.86432 1.75252C2.60089 1.88674 2.38672 2.10091 2.25249 2.36434C2.19378 2.47957 2.14938 2.63879 2.12516 2.93519C2.10037 3.23859 2.0999 3.62997 2.0999 4.19993V9.29993C2.0999 9.86988 2.10037 10.2613 2.12516 10.5647C2.14938 10.8611 2.19378 11.0203 2.25249 11.1355C2.38672 11.3989 2.60089 11.6131 2.86432 11.7473C2.97955 11.806 3.13877 11.8505 3.43517 11.8747C3.73857 11.8995 4.12995 11.8999 4.6999 11.8999H11.2999C11.8699 11.8999 12.2612 11.8995 12.5646 11.8747C12.861 11.8505 13.0203 11.806 13.1355 11.7473C13.3989 11.6131 13.6131 11.3989 13.7473 11.1355C13.806 11.0203 13.8504 10.8611 13.8746 10.5647C13.8994 10.2613 13.8999 9.86988 13.8999 9.29993V6.19993C13.8999 5.62997 13.8994 5.23859 13.8746 4.93519C13.8504 4.63879 13.806 4.47957 13.7473 4.36434C13.6131 4.10091 13.3989 3.88674 13.1355 3.75252C13.0203 3.6938 12.861 3.6494 12.5646 3.62518C12.2612 3.60039 11.8699 3.59993 11.2999 3.59993H9.6224C9.60415 3.59993 9.58614 3.59993 9.56837 3.59994C9.20442 3.60006 8.93852 3.60015 8.67875 3.54684C8.44927 3.49974 8.22721 3.42185 8.01859 3.31527C7.78244 3.19462 7.57487 3.02845 7.29074 2.80099C7.27687 2.78988 7.26281 2.77863 7.24856 2.76723L6.50161 2.16967C6.15797 1.89476 6.04935 1.81149 5.93527 1.7532C5.82294 1.69582 5.70337 1.65387 5.5798 1.62851ZM4.93143 0.399914C5.29539 0.39979 5.56129 0.3997 5.82105 0.453012C6.05053 0.500109 6.2726 0.578005 6.48122 0.684585C6.71736 0.805229 6.92494 0.971405 7.20906 1.19886C7.22294 1.20997 7.23699 1.22122 7.25124 1.23262L7.99819 1.83018C8.34183 2.10509 8.45045 2.18837 8.56453 2.24665C8.67686 2.30404 8.79644 2.34598 8.92 2.37134C9.04549 2.3971 9.18233 2.39993 9.6224 2.39993H11.2999L11.325 2.39993C11.8637 2.39992 12.3043 2.39991 12.6624 2.42917C13.033 2.45945 13.3677 2.52404 13.6803 2.68331C14.1695 2.93258 14.5672 3.33033 14.8165 3.81955C14.9758 4.13214 15.0404 4.46686 15.0707 4.83747C15.0999 5.19553 15.0999 5.6361 15.0999 6.17481V6.19993V9.29993V9.32505C15.0999 9.86375 15.0999 10.3043 15.0707 10.6624C15.0404 11.033 14.9758 11.3677 14.8165 11.6803C14.5672 12.1695 14.1695 12.5673 13.6803 12.8165C13.3677 12.9758 13.033 13.0404 12.6624 13.0707C12.3043 13.0999 11.8637 13.0999 11.325 13.0999H11.2999H4.6999H4.67478C4.13607 13.0999 3.6955 13.0999 3.33745 13.0707C2.96684 13.0404 2.63212 12.9758 2.31953 12.8165C1.83031 12.5673 1.43256 12.1695 1.18329 11.6803C1.02401 11.3677 0.959424 11.033 0.929144 10.6624C0.89989 10.3043 0.899896 9.86376 0.899903 9.32506L0.899903 9.29993V4.19993L0.899903 4.17479C0.899896 3.63609 0.89989 3.19552 0.929144 2.83747C0.959424 2.46686 1.02401 2.13214 1.18329 1.81955C1.43256 1.33033 1.83031 0.93258 2.31953 0.683309C2.63212 0.524036 2.96684 0.459447 3.33745 0.429167C3.6955 0.399913 4.13607 0.399919 4.67477 0.399926L4.6999 0.399926H4.8774C4.89565 0.399926 4.91366 0.39992 4.93143 0.399914Z"
															fill="#AEBAD6" />
													</svg>
													<span @click="getVodFiles(item._id)" class="d-block text-truncate">{{ item.liveParent ?
														'(Live-to-Vod) ' + item.name : item.name
													}}</span>
												</div>
												<b-collapse accordion="vod-files" role="tabpanel" :id="'folder' + item._id" class="mt-2 w-100">
													<b-list-group v-show="!loading">
														<b-list-group-item button variant="dark-3" v-for="(file, index) in  vodFiles" :key="index"
															@click="setElement(item, file)"
															class="d-flex align-items-center text-dark-8 px-3 py-2 text-s-s text-truncate flex-shrink-0">
															<svg class="ml-3 mr-2 flex-shrink-0" width="12" height="16" viewBox="0 0 12 16" fill="none"
																xmlns="http://www.w3.org/2000/svg">
																<path fill-rule="evenodd" clip-rule="evenodd"
																	d="M5.64988 2.10035C5.58321 2.10004 5.50862 2.09994 5.42464 2.09994L3.94986 2.09996C3.37992 2.09997 2.98854 2.10044 2.68514 2.12523C2.38875 2.14946 2.22953 2.19386 2.1143 2.25258C1.85088 2.3868 1.63671 2.60097 1.50249 2.8644C1.44378 2.97963 1.39937 3.13884 1.37516 3.43524C1.35037 3.73864 1.3499 4.13001 1.3499 4.69996V11.3C1.3499 11.8699 1.35037 12.2613 1.37516 12.5647C1.39938 12.8611 1.44378 13.0204 1.5025 13.1356C1.63672 13.399 1.85089 13.6132 2.11432 13.7474C2.22955 13.8061 2.38877 13.8505 2.68517 13.8747C2.98858 13.8995 3.37996 13.9 3.94992 13.9L8.05009 13.9C8.62003 13.9 9.0114 13.8995 9.3148 13.8747C9.61119 13.8505 9.77041 13.8061 9.88564 13.7474C10.1491 13.6131 10.3632 13.399 10.4975 13.1356C10.5562 13.0203 10.6006 12.8611 10.6248 12.5647C10.6496 12.2613 10.6501 11.8699 10.6501 11.3L10.6501 7.32542C10.6501 7.24133 10.65 7.16664 10.6497 7.09991H7.24988C6.36622 7.09991 5.64988 6.38356 5.64988 5.49991V2.10035ZM10.2911 5.89991C10.2072 5.80705 10.0843 5.68263 9.88861 5.4869L7.26316 2.86146C7.06724 2.66554 6.94276 2.54262 6.84988 2.45874V5.49991C6.84988 5.72082 7.02896 5.89991 7.24988 5.89991H10.2911ZM6.52866 0.971761C6.22813 0.899614 5.91596 0.899743 5.48849 0.899919L5.42463 0.899937L3.94985 0.89996L3.92471 0.89996C3.38602 0.899961 2.94545 0.899962 2.58741 0.929221C2.2168 0.959506 1.88209 1.0241 1.5695 1.18337C1.08029 1.43265 0.682547 1.8304 0.433281 2.31961C0.27401 2.6322 0.209423 2.96692 0.179144 3.33752C0.14989 3.69557 0.149896 4.13612 0.149903 4.67481V4.67482V4.69996V11.3V11.3251V11.3251C0.149896 11.8638 0.14989 12.3044 0.179144 12.6625C0.209424 13.0331 0.274013 13.3678 0.433288 13.6804C0.682561 14.1696 1.08031 14.5673 1.56954 14.8166C1.88213 14.9759 2.21685 15.0405 2.58746 15.0708C2.9455 15.1 3.38605 15.1 3.92473 15.1H3.94993L8.05009 15.1H8.07518H8.07522C8.61392 15.1 9.05448 15.1 9.41252 15.0707C9.78313 15.0404 10.1178 14.9758 10.4304 14.8166C10.9196 14.5673 11.3174 14.1696 11.5667 13.6804C11.7259 13.3678 11.7905 13.0331 11.8208 12.6625C11.8501 12.3044 11.8501 11.8638 11.8501 11.3252V11.3251V11.3L11.8501 7.32544L11.8501 7.26158C11.8503 6.8341 11.8505 6.52193 11.7783 6.2214C11.7146 5.9561 11.6096 5.70248 11.467 5.46985C11.3055 5.20632 11.0847 4.98567 10.7823 4.68352L10.7371 4.63838L8.11169 2.01293L8.06654 1.96776C7.76439 1.66537 7.54374 1.44455 7.28022 1.28306C7.04759 1.1405 6.79396 1.03545 6.52866 0.971761Z"
																	fill="currentColor" />
															</svg>
															<span class="d-block text-truncate">{{ file.fileName }}</span>
														</b-list-group-item>
													</b-list-group>
													<div class="col-6" v-if="loading">
														<Spinner text="Retrieving data..." classes="text-dark-8 my-2 text-left"
															textClasses="text-s-xs" spinner-color="var(--c-dark-8)" spinner-size="14px" />
													</div>
												</b-collapse>
											</b-list-group-item>
										</b-list-group>
									</b-tab>
								</b-tabs>
							</b-dropdown-text>
						</b-dropdown>
						<hr class="mb-2 mt-4">
						<div class="d-flex justify-content-between align-items-center">
							<h6 class="text-dark-8 text-s-s text-500 m-0 text-nowrap">iFrame Widget</h6>
							<b-dropdown :disabled="hasLiveSubscription && !hasLiveSubscription.enabled" right variant="transparent"
								size="md" id="iframe" menu-class="bg-dark-3 dropdown-menu_md"
								toggle-class="justify-content-end justify-content-md-between" class="w-100">
								<template #button-content>
									{{ iframe }}
								</template>
								<b-dropdown-item class="d-flex align-items-center" @click="changeIframe('Responsive')">
									<svg class="mr-2" width="13" height="10" viewBox="0 0 13 10" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M11.9243 1.42413C11.9243 1.42415 11.9243 1.42416 11.9243 1.42417L11.9243 1.42419L11.9239 1.42458L11.922 1.42645L11.914 1.43449L11.8813 1.46748C11.8523 1.49685 11.809 1.54083 11.7529 1.59845C11.6405 1.71369 11.4766 1.88342 11.2717 2.09983C10.862 2.53278 10.2892 3.15194 9.63906 3.895C8.33538 5.3849 6.73413 7.35729 5.5087 9.31786C5.40807 9.47886 5.23717 9.58273 5.04792 9.59792C4.85867 9.61311 4.67339 9.53783 4.54836 9.39494L1.04836 5.39494C0.830155 5.14556 0.855426 4.7665 1.10481 4.5483C1.35419 4.33009 1.73325 4.35536 1.95146 4.60474L4.92726 8.00565C6.12685 6.19988 7.5609 4.4477 8.73597 3.10479C9.3983 2.34786 9.98182 1.71702 10.4002 1.27497C10.6094 1.05389 10.7775 0.879863 10.8937 0.760729C10.9518 0.701158 10.9969 0.655297 11.0277 0.624126L11.063 0.588503L11.0722 0.57918L11.0747 0.576681L11.0754 0.575977L11.0756 0.575762C11.0757 0.575692 11.0758 0.575638 11.5 0.999902L11.0758 0.575638C11.3101 0.341324 11.69 0.341324 11.9243 0.575638C12.1586 0.809942 12.1586 1.18982 11.9243 1.42413Z"
											:fill="iframe === 'Responsive' ? 'currentColor' : 'transparent'" />
									</svg>
									Responsive
								</b-dropdown-item>
								<b-dropdown-item class="d-flex align-items-center" @click="changeIframe('Fixed Size')">
									<svg class="mr-2" width="13" height="10" viewBox="0 0 13 10" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M11.9243 1.42413C11.9243 1.42415 11.9243 1.42416 11.9243 1.42417L11.9243 1.42419L11.9239 1.42458L11.922 1.42645L11.914 1.43449L11.8813 1.46748C11.8523 1.49685 11.809 1.54083 11.7529 1.59845C11.6405 1.71369 11.4766 1.88342 11.2717 2.09983C10.862 2.53278 10.2892 3.15194 9.63906 3.895C8.33538 5.3849 6.73413 7.35729 5.5087 9.31786C5.40807 9.47886 5.23717 9.58273 5.04792 9.59792C4.85867 9.61311 4.67339 9.53783 4.54836 9.39494L1.04836 5.39494C0.830155 5.14556 0.855426 4.7665 1.10481 4.5483C1.35419 4.33009 1.73325 4.35536 1.95146 4.60474L4.92726 8.00565C6.12685 6.19988 7.5609 4.4477 8.73597 3.10479C9.3983 2.34786 9.98182 1.71702 10.4002 1.27497C10.6094 1.05389 10.7775 0.879863 10.8937 0.760729C10.9518 0.701158 10.9969 0.655297 11.0277 0.624126L11.063 0.588503L11.0722 0.57918L11.0747 0.576681L11.0754 0.575977L11.0756 0.575762C11.0757 0.575692 11.0758 0.575638 11.5 0.999902L11.0758 0.575638C11.3101 0.341324 11.69 0.341324 11.9243 0.575638C12.1586 0.809942 12.1586 1.18982 11.9243 1.42413Z"
											:fill="iframe === 'Fixed Size' ? 'currentColor' : 'transparent'" />
									</svg>
									Fixed Size
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<b-input-group size="md" class="">
							<b-form-input placeholder="Dynamic Player iFrame Code" :disabled="!dynamicPlayerUrl" :value="iFrameCode"
								@click="clipboardCopy(iFrameCode)" readonly></b-form-input>
							<b-input-group-append>
								<b-button :disabled="!dynamicPlayerUrl" class="py-1 px-2" variant="icon" size="md"
									@click="clipboardCopy(iFrameCode)">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M14.1667 6V6C15.4098 6 16.0314 6 16.5168 6.21614C17.0812 6.46742 17.5326 6.91877 17.7839 7.48316C18 7.96861 18 8.59018 18 9.83334V14C18 15.4001 18 16.1002 17.7275 16.635C17.4878 17.1054 17.1054 17.4878 16.635 17.7275C16.1002 18 15.4001 18 14 18H9.83334C8.59018 18 7.96861 18 7.48316 17.7839C6.91877 17.5326 6.46742 17.0812 6.21614 16.5168C6 16.0314 6 15.4098 6 14.1667V14.1667"
											stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path
											d="M2 6C2 4.59987 2 3.8998 2.27248 3.36502C2.51217 2.89462 2.89462 2.51217 3.36502 2.27248C3.8998 2 4.59987 2 6 2H10C11.4001 2 12.1002 2 12.635 2.27248C13.1054 2.51217 13.4878 2.89462 13.7275 3.36502C14 3.8998 14 4.59987 14 6V10C14 11.4001 14 12.1002 13.7275 12.635C13.4878 13.1054 13.1054 13.4878 12.635 13.7275C12.1002 14 11.4001 14 10 14H6C4.59987 14 3.8998 14 3.36502 13.7275C2.89462 13.4878 2.51217 13.1054 2.27248 12.635C2 12.1002 2 11.4001 2 10V6Z"
											stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</b-button>
							</b-input-group-append>
						</b-input-group>
						<h6 class="text-dark-8 text-s-s text-500 mt-4 text-nowrap">Embed URL</h6>
						<b-input-group :disabled="!dynamicPlayerUrl" size="md" class="">
							<b-form-input placeholder="Dynamic Player URL" :disabled="!dynamicPlayerUrl" :value="dynamicPlayerUrl"
								@click="clipboardCopy(dynamicPlayerUrl)" readonly></b-form-input>
							<b-input-group-append>
								<b-button :disabled="!dynamicPlayerUrl" class="py-1 px-2" variant="icon" size="md"
									@click="clipboardCopy(dynamicPlayerUrl)">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M14.1667 6V6C15.4098 6 16.0314 6 16.5168 6.21614C17.0812 6.46742 17.5326 6.91877 17.7839 7.48316C18 7.96861 18 8.59018 18 9.83334V14C18 15.4001 18 16.1002 17.7275 16.635C17.4878 17.1054 17.1054 17.4878 16.635 17.7275C16.1002 18 15.4001 18 14 18H9.83334C8.59018 18 7.96861 18 7.48316 17.7839C6.91877 17.5326 6.46742 17.0812 6.21614 16.5168C6 16.0314 6 15.4098 6 14.1667V14.1667"
											stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path
											d="M2 6C2 4.59987 2 3.8998 2.27248 3.36502C2.51217 2.89462 2.89462 2.51217 3.36502 2.27248C3.8998 2 4.59987 2 6 2H10C11.4001 2 12.1002 2 12.635 2.27248C13.1054 2.51217 13.4878 2.89462 13.7275 3.36502C14 3.8998 14 4.59987 14 6V10C14 11.4001 14 12.1002 13.7275 12.635C13.4878 13.1054 13.1054 13.4878 12.635 13.7275C12.1002 14 11.4001 14 10 14H6C4.59987 14 3.8998 14 3.36502 13.7275C2.89462 13.4878 2.51217 13.1054 2.27248 12.635C2 12.1002 2 11.4001 2 10V6Z"
											stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</b-button>
								<b-button :disabled="!dynamicPlayerUrl" variant="icon" class="py-1 px-2" size="md"
									:href="dynamicPlayerUrl" target="_blank">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8.5 4.5H7.3C5.61984 4.5 4.77976 4.5 4.13803 4.82698C3.57354 5.1146 3.1146 5.57354 2.82698 6.13803C2.5 6.77976 2.5 7.61984 2.5 9.3V12.7C2.5 14.3802 2.5 15.2202 2.82698 15.862C3.1146 16.4265 3.57354 16.8854 4.13803 17.173C4.77976 17.5 5.61984 17.5 7.3 17.5H10.7C12.3802 17.5 13.2202 17.5 13.862 17.173C14.4265 16.8854 14.8854 16.4265 15.173 15.862C15.5 15.2202 15.5 14.3802 15.5 12.7V11.5"
											stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M10.5 9.5L17.5 2.5M17.5 2.5H12.5M17.5 2.5V7.5" stroke="currentColor" stroke-width="1.5"
											stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-tabs class="tabs-light mt-5" nav-class="tabs-light-border">
							<b-tab @click="changeRouteQuery('interface')" title="Player interface"
								:active="this.$route.query && this.$route.query.tab === 'interface'">
								<DynamicPlayerInterface />
							</b-tab>
							<b-tab @click="changeRouteQuery('functions')" title="Player functions"
								:active="this.$route.query && this.$route.query.tab === 'functions'">
								<DynamicPlayerFunctions />
							</b-tab>
							<b-tab @click="changeRouteQuery('security')" title="Security"
								:active="this.$route.query && this.$route.query.tab === 'security'">
								<DynamicPlayerSecurity />
							</b-tab>
							<b-tab @click="changeRouteQuery('analytics')" title="Analytics"
								:active="this.$route.query && this.$route.query.tab === 'analytics'">

								<div class="analytics-tab-container">
									<h3 class="text-s-m text-500 mt-4 mb-2">Checkout Analytics</h3>
									<p v-if="player.subSource || player.source" class="text-dark-8 text-s-s">Clicking on the button will
										open Analytics in a new window by filtering the source.</p>
									<p v-else class="text-dark-8 text-s-s">Please select a source to open analytics.</p>

									<b-button :disabled="!player.subSource && !player.source" variant="primary"
										@click="onClickAnalytics">Checkout analytics of your video</b-button>
								</div>
							</b-tab>
						</b-tabs>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<b-modal modal-class="modal_tutorial" id="modal_tutorial" centered>
			<iframe src="https://www.youtube.com/embed/ouEzsml7whU" title="YouTube video player" frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen></iframe>
		</b-modal>
		<demo-video-modal videoid="9UJ1aZUoaRqiJ86YfFYKG" />
		<confirm-modal modalId="delete-player" message="Are you sure you want to delete your Dynamic Player?"
			modal-type="danger" @modal-confirm="onDeletePlayer" />
	</b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import DynamicService from '@/services/DynamicService'
import StreamStatsService from '@/services/StreamStatsService'
import DemoVideoModal from '@/components/modals/DemoVideoModal.vue';
import Spinner from "@/components/ui/Spinner.vue"
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import DynamicNav from '@/components/ui/DynamicNav.vue'
import StreamPlayerDynamic from '@/components/DynamicPlayer/StreamPlayerDynamic.vue'
import StreamPlayerHlsDynamic from '@/components/DynamicPlayer/StreamPlayerHlsDynamic.vue'

import DynamicPlayerInterface from '@/components/DynamicPlayer/DynamicPlayerInterface.vue'
import DynamicPlayerFunctions from '@/components/DynamicPlayer/DynamicPlayerFunctions.vue'
import DynamicPlayerSecurity from '@/components/DynamicPlayer/DynamicPlayerSecurity.vue'


export default {
	name: 'DynamicManage',
	components: {
		Spinner,
		ConfirmModal,
		DynamicNav,
		StreamPlayerDynamic,
		StreamPlayerHlsDynamic,
		DynamicPlayerInterface,
		DemoVideoModal,
		DynamicPlayerFunctions,
		DynamicPlayerSecurity
	},
	data() {
		return {
			source: {
				name: 'Select source'
			},
			search: '',
			loading: false,
			mediaPulse: null,
			scopeAlive: true,
			iframe: 'Responsive',
			streamPreviewSpecsUrl: null,
			streamPreviewSpecsType: null,
			mediaPulse: null,
			mediaPulseTimeoutCtrl: null,
			allowEditTitle: false,
			dividerPosition: 25
		};
	},
	computed: {
		...mapGetters({
			loadingStatus: "Ui/loadingStatus",
			player: "DynamicPlayers/dynamicPlayer",
			players: "DynamicPlayers/dynamicPlayers",
			playerLoaded: "DynamicPlayers/dynamicPlayerLoaded",
			allInOneStreams: "Streams/allInOneStreams",
			vodStreams: "Streams/vodStreams",
			vodFiles: "Streams/vodFiles",
			hasLiveSubscription: "User/hasLiveSubscription",
			hasVodSubscription: "User/hasVodSubscription",
			dynamicPlayerFeatures: "User/dynamicPlayerFeatures",
		}),
		allInOneStreamsFiltered() {
			const allInOneStreams = _.cloneDeep(this.allInOneStreams.filter(stream => stream.name.toLowerCase().includes(this.search.toLowerCase())))
			return allInOneStreams.sort(function (a, b) {
				return new Date(b.creationTime) - new Date(a.creationTime)
			})
		},
		vodStreamsFiltered() {
			const vodStreams = _.cloneDeep(this.vodStreams.filter(stream => stream.name.toLowerCase().includes(this.search.toLowerCase()) && stream.totalFiles > 0))
			return vodStreams.sort(function (a, b) {
				return new Date(b.creationTime) - new Date(a.creationTime)
			})
		},
		playerUrl() {
			if (this.player && this.player.subSource && this.player.source.liveParent) {
				const range = `${this.player.subSource.data.from}-${this.player.subSource.data.duration}`
				return `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/${this.player.source.key}?range=${range}&preview=true&abr=${this.player.subSource.data.abr ? 'true' : 'false'}`
					+ (this.player.subSource.data.namedHls ? '&namedHls=true' : '');
			} else if (this.player && this.player.subSource) {
				const playerUri = `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/vod/${this.player.subSource.data.id}?preview=true`
				return playerUri
			} else return null
		},
		sourceLiveStream() {
			if (this.player && this.player.source && !this.player.subSource) {
				return this.allInOneStreams.find(stream => stream._id === this.player.source._id)
			} else return null
		},
		dynamicPlayerUrl() {
			const playerUrl = `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/${this.player.key}`
			return playerUrl
		},
		iFrameCode() {
			if (this.iframe === 'Responsive' && this.dynamicPlayerUrl) {
				return `<iframe src="${this.dynamicPlayerUrl}" width="100%" style="aspect-ratio: 16/9; min-height: 340px;" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen  webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
			} else if (this.iframe === 'Fixed Size' && this.dynamicPlayerUrl) {
				return `<iframe src="${this.dynamicPlayerUrl}" width="590" height="431" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
			} else return
		},
		playerSourceType() {
			if (this.player && this.player.source && !this.player.subSource) {
				return 'LiveStream'
			} else if (this.player && this.player.subSource && this.player.source && this.player.source.liveParent) {
				return 'LiveToVod'
			} else if (this.player && this.player.subSource && this.player.source && !this.player.source.liveParent) {
				return 'Vod'
			} else return null
		},
		playerSourceTitle() {
			if (this.playerSourceType === 'LiveStream') {
				return this.player.source.name
			} else if (this.playerSourceType === 'LiveToVod') {
				return this.player.subSource.data.name
			} else if (this.playerSourceType === 'Vod') {
				return this.player.subSource.data.fileName
			} else if (this.player && this.player.subSource && this.player.source && !this.player.source.liveParent) {
				return 'Vod'
			} else return null
		},
	},
	watch: {
		async sourceLiveStream() {
			if (this.sourceLiveStream) {
				await this.unsubscribeMediaPulse()
				await this.subscribeMediaPulse()
			}
			// console.log('sourceLiveStream was changed');
		},
		async mediaPulse() {
			this.onMediaPulseChanged();
			// console.log('mediapulse was changed');
		},
	},
	async mounted() {
		await this.$store.dispatch('DynamicPlayers/getPlayers');
		await this.$store.dispatch('DynamicPlayers/getPlayer', this.$route && this.$route.params.playerId);
		await this.$store.dispatch('Streams/getStreams');
	},
	destroyed() {
		this.scopeAlive = false
		this.unsubscribeMediaPulse()

	},
	methods: {
		onClickAnalytics() {
			let id = '';
			if (this.playerSourceType === 'Vod') {
				id = this.player.subSource.data.id;
			} else {
				id = this.player.source?.key;
			}
			if (id) {
				const route = this.$router.resolve({ name: 'AnalyticsDashboardWithRoute', params: { videoId: id } });
				window.open(route.href, '_blank');
			}
		},
		async onDeletePlayer() {
			const playerName = this.player.name
			try {
				await DynamicService.deletePlayer(
					this.player._id
				)
				await this.$store.dispatch('DynamicPlayers/getPlayers');
				this.$notify({
					group: 'success',
					text: `Dynamic Player ${playerName} is completely deleted from your account`,
				})
				this.$router.push({
					name: "DynamicDashboard",
				})
			} catch (err) {
				console.log(err)
				this.$notify({
					group: 'error',
					title: "Couldn't delete dynamic player",
					text: err.message
				});
			}
		},
		async setElement(item, file) {
			try {
				if (item && file) {
					await DynamicService.setVodPlayer(
						this.player._id,
						this.player.name,
						item._id,
						file._id
					)
					this.$refs.source.hide(true)
					this.$notify({
						group: 'success',
						text: `Source set`,
					})
				} else if (item) {
					await DynamicService.setLiveStreamPlayer(
						this.player._id,
						this.player.name,
						item._id
					)
					this.$refs.source.hide(true)
					this.$notify({
						group: 'success',
						text: `Source set`,
					})
				} else {
					await DynamicService.setLiveStreamPlayer(
						this.player._id,
						this.player.name,
						null
					)
					this.$notify({
						group: 'success',
						text: `Source removed`,
					})
				}
				await this.$store.dispatch('DynamicPlayers/getPlayers');
				await this.$store.dispatch('DynamicPlayers/getPlayer', this.$route && this.$route.params.playerId);
			} catch (err) {
				console.log(err)
			}
		},
		async getVodFiles(vodId) {
			this.$root.$emit('bv::toggle::collapse', 'folder' + vodId)
			this.loading = true
			await this.$store.dispatch('Streams/getVodFilesByVodId', vodId)
			this.loading = false
		},
		async togglePlayer() {
			await DynamicService.togglePlayer(
				this.player._id
			)
			await this.$store.dispatch('DynamicPlayers/getPlayer', this.$route && this.$route.params.playerId)
			this.$notify({
				group: 'success',
				text: `Status changed`,
			})
		},
		subscribeMediaPulse() {
			const streamKey = this.sourceLiveStream.key
			const streamEnabled = this.sourceLiveStream.enabled
			const self = this;
			(async function loop() {
				if (!self.scopeAlive) return

				let timeoutInterval = 5000
				let shouldUpdatePulse = streamEnabled
				if (document.hidden) {
					shouldUpdatePulse = false
					timeoutInterval = 6000
				}

				if (shouldUpdatePulse) {
					if (!document.hasFocus()) {
						timeoutInterval = 14000
					}
				}
				if (shouldUpdatePulse) {
					try {
						const pulseObject = await StreamStatsService.getStreamMediaPulse(
							streamKey
						)
						self.onMediaPulse(pulseObject);

						// console.log('mediPulse stream', self.stream)
						if (self.stream.failoverIngest) {
							const backupPulseObject = await StreamStatsService.getStreamMediaPulse(
								`${streamKey}_backup`
							)
							self.onBackupMediaPulse(backupPulseObject)
						}
					} catch (e) { }
				} else self.mediaPulse = null
				// reschedule
				self.mediaPulseTimeoutCtrl = setTimeout(loop, timeoutInterval);
			})();
		},
		onMediaPulse(pulseObject = {}) {
			if (this.mediaPulse && this.mediaPulse.withoutPushStats) {
				const oldPushStats = this.mediaPulse.push_stats;
				pulseObject.push_stats = oldPushStats;
			}
			this.mediaPulse = pulseObject;
			this.streamAlive =
				this.stream.enabled && this.mediaPulse && this.mediaPulse.alive;
			this.streamFps = this.mediaPulse.fps;
		},
		async onMediaPulseChanged() {
			if (this.mediaPulse && this.mediaPulse.isWowza === true) {
				this.streamPreviewSpecsType = 'hls';
				this.streamPreviewSpecsUrl = `https://wowza-stage.castr.io/static/${this.sourceLiveStream.key}/playlist_sfm4s.m3u8`;
			}

			if (_.isEmpty(this.streamPreviewSpecs) && this.sourceLiveStream && this.sourceLiveStream.key) {
				this.streamPreviewSpecsType = 'mse';
				this.streamPreviewSpecsUrl = `wss://wowza-stage.castr.io/${this.sourceLiveStream.key}/mse_ld?tracks=v1a1`;
			}
		},
		unsubscribeMediaPulse() {
			clearTimeout(this.mediaPulseTimeoutCtrl);
		},
		changeIframe(type) {
			this.iframe = type
		},
		clipboardCopy(text) {
			try {
				if (text instanceof Function) text = text();

				this.$copyText(text);
				this.$notify({ group: 'info', text: 'Copied to clipboard' });
			} catch (e) { }
		},
		changeRouteQuery(item) {
			this.$router.replace({ query: { ...this.$route.query, tab: item } })
		},
		editPlayerName(e) {
			this.allowEditTitle = true
			setTimeout(() => {
				this.$refs.title.focus()
			}, "100");
		},
		async saveNewPlayerName(e) {
			e.preventDefault();
			e.stopPropagation();
			const newName = e.target.innerText
			if (newName != this.player.name) {
				await DynamicService.renamePlayer(
					this.player._id,
					newName,
				)
				this.allowEditTitle = false
				this.$notify({ group: 'info', text: 'Your player was renamed' })
				await this.$store.dispatch('DynamicPlayers/getPlayer', this.$route && this.$route.params.playerId)
				await this.$store.dispatch('DynamicPlayers/getPlayers');
			}
		},
		showDeleteModal() {
			this.$root.$emit("bv::show::modal", 'delete-player');
		},
		async goToPlayer(id) {
			if (id != this.$route.params.playerId) {
				await this.$store.dispatch('DynamicPlayers/setCurrentPlayer', id);
				await this.$store.dispatch('DynamicPlayers/getPlayer', id);
				this.$router.push({
					name: "DynamicManage",
					params: { playerId: id },
				});
			} else return
		},
		showAddPlayerModal() {
			// if(!this.checkManagePermissions()) return;
			this.$bvModal.show('modal-add-dynamic-player');
		},
		handleDragging(e) {
			e.preventDefault();
			const position = e.pageX
			const wrapper = document.getElementById('resizible-wrapper')
			const windowWidth = window.innerWidth
			const percentage = ((position - 260) / wrapper.offsetWidth) * 100
			if (percentage >= 20 && percentage <= 30) {
				this.dividerPosition = percentage.toFixed(2)
			}
			if (position - 260 <= 0) {
				document.removeEventListener('mousemove', this.handleDragging)
			}
		},
		startDragging() {
			document.addEventListener('mousemove', this.handleDragging)
		},
		endDragging() {
			document.removeEventListener('mousemove', this.handleDragging)
		}
	},
}

</script>

<style scoped>
.title {
	padding: .25rem .5rem;
	margin: 0 -.5rem;
	transition: .3s;
	word-break: break-all;
}

.title:hover {
	background-color: var(--c-dark-2);
	transition: .3s;
}

.title-editable {
	background-color: var(--c-dark-2);
	outline: none;
	box-shadow: 0 0 2px rgba(0, 0, 0, .3);
}

:deep(.stream-source-menu) {
	width: 22rem;
	border-radius: 6px;
}

:deep(.b-dropdown.show>.stream-source-menu) {
	z-index: 1040;
}

.stream-source-list {
	max-height: 22rem;
	overflow-y: auto;
}

.stream-source-list .list-group-item-action:hover,
.stream-source-list .list-group-item-action:focus {
	background-color: var(--c-dark-4);
	color: #fff;
	outline: none;
}

:deep(.tabs-light-border) {
	border-bottom: 1px solid var(--c-dark-4);
}

.mw-vod {
	max-width: 80%;
}

.select-arrow {
	position: absolute;
	right: 3rem;
	top: 3.5rem;
}

@media (max-width: 767px) {
	.video-placeholder {
		margin: 0 -15px;
	}
}

@media (min-width: 768px) {
	.video-placeholder {
		border-radius: .5rem;
	}
}

.dynamic_players_demo:hover {
	text-decoration: underline;
	color: var(--c-dark-6);
}

.dynamic_players_doc {
	color: var(--c-dark-6);
}

.dynamic_players_doc:hover {
	color: var(--c-dark-6);
}

.analytics-tab-container {
	text-align: center;
}

.analytics-tab-container p {
	color: rgba(174, 186, 214, 1);
	font-weight: 400;
}</style>
